<table class="table table-borderless mb-0" wlAutomationId="costs.electricity">
  <thead>
    <tr>
      <th id="energy-title" scope="col">
        @if (energyTitle) {
          <span class="energy-title" *scText="energyTitle" wlCSCapture></span>
        }
      </th>
      <th
        id="summer"
        scope="col"
        class="text-end"
        [innerHTML]="getSummerDate | safeHtml"
        wlCSCapture
      ></th>
      <th
        id="winter"
        scope="col"
        class="text-end"
        [innerHTML]="getWinterDate | safeHtml"
        wlCSCapture
      ></th>
    </tr>
  </thead>
  <tbody>
    @if (showRedeliveryCosts) {
      <tr>
        <th id="delivery-title" headers="energy-title" colspan="3" scope="col">
          @if (deliveryTitle) {
            <span class="h5" *scText="deliveryTitle" wlCSCapture></span>
          }
        </th>
      </tr>
    }
    @for (tariffPeriod of tariffPeriods; track tariffPeriod; let i = $index) {
      <tr>
        <th [id]="'tariff-' + i" scope="row">
          <em wlCSCapture
            >{{ 'per' | translate }}
            {{ 'ElectricityUsageUnit' | translate }}</em
          ><br />
          <span
            [innerHTML]="tariffPeriod.description | safeHtml"
            wlCSCapture
          ></span>
        </th>
        <td
          [headers]="'summer delivery-title tariff-' + i"
          class="text-end"
          wlCSCapture
        >
          {{ tariffPeriod?.summerPrice | currency: 'EUR' : 'symbol' : '1.5' }}
        </td>
        <td
          [headers]="'winter delivery-title tariff-' + i"
          class="text-end"
          wlCSCapture
        >
          {{ tariffPeriod?.winterPrice | currency: 'EUR' : 'symbol' : '1.5' }}
        </td>
      </tr>
    }
    <tr wlAutomationId="costs.electricityDelivery" class="mb-1">
      <th id="fixed-delivery" colspan="2" scope="row" class="fst-italic">
        @if (fixedDeliveryCostsLabel) {
          <span *scText="fixedDeliveryCostsLabel" wlCSCapture></span>
        }
      </th>
      <td headers="delivery-title fixed-delivery" class="text-end" wlCSCapture>
        {{ fixedDeliveryCosts }}
      </td>
    </tr>
    @if (showRedeliveryCosts) {
      <tr aria-hidden="true">
        <td colspan="3">
          <hr />
        </td>
      </tr>
      <tr>
        <th id="redelivery-title" colspan="3" scope="col">
          @if (redeliveryTitle) {
            <span class="h5" *scText="redeliveryTitle" wlCSCapture></span>
          }
        </th>
      </tr>
      <tr>
        <td colspan="3">
          {{ fixedRedeliveryCostsScale }}
        </td>
      </tr>
      <tr wlAutomationId="costs.electricityRedelivery">
        <th
          id="fixed-redelivery"
          headers="redelivery-title"
          colspan="2"
          scope="row"
          class="fst-italic"
        >
          @if (fixedRedeliveryCostsLabel) {
            <span *scText="fixedRedeliveryCostsLabel" wlCSCapture></span>
          }
        </th>
        <td
          headers="redelivery-title fixed-redelivery"
          class="text-end"
          wlCSCapture
        >
          {{ fixedRedeliveryCosts }}
        </td>
      </tr>
      <tr>
        <td
          colspan="3"
          class="font-size-sm microcopy fst-italic"
          *wlGenericRichText="redeliveryDescription"
        ></td>
      </tr>
    }
  </tbody>
</table>
